import __var_0__ from '@stdlib/utils/define-nonenumerable-read-only-property';
import __var_1__ from './main.js';
import __var_2__ from './sync.js';
/**

*
* Copyright (c) 2019 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Open a file.
*
* @module @stdlib/fs/open
*
* @example
* var closeSync = require( '@stdlib/fs/close' ).sync;
* var open = require( '@stdlib/fs/open' );
*
* function onOpen( error, fd ) {
*     if ( error ) {
*         throw error;
*     }
*     closeSync( fd );
* }
* open( __filename, onOpen );
*
* @example
* var closeSync = require( '@stdlib/fs/close' ).sync;
* var openSync = require( '@stdlib/fs/open' ).sync;
*
* var fd = openSync( __filename );
* if ( fd instanceof Error ) {
*     throw fd;
* }
* closeSync( fd );
*/

// MODULES //
var setReadOnly = __var_0__;
var main = __var_1__;
var sync = __var_2__;


// MAIN //

setReadOnly( main, 'sync', sync );


// EXPORTS //
export default main;
